import React from 'react';

import { ReactComponent as AITypeFailureComponentDarkIcon } from '@assets/svg/add-ai/ic-failureComponent-dark.svg';
import { ReactComponent as AITypeFailureComponentIcon } from '@assets/svg/add-ai/ic-failureComponent.svg';
import { ReactComponent as AITypeFailureHardwareDarkIcon } from '@assets/svg/add-ai/ic-failureHardware-dark.svg';
import { ReactComponent as AITypeFailureHardwareIcon } from '@assets/svg/add-ai/ic-failureHardware.svg';
import { ReactComponent as AITypeRequestComponentDarkIcon } from '@assets/svg/add-ai/ic-requestComponent-dark.svg';
import { ReactComponent as AITypeRequestComponentIcon } from '@assets/svg/add-ai/ic-requestComponent.svg';
import { ReactComponent as AITypeRequestHardwareDarkIcon } from '@assets/svg/add-ai/ic-requestHardware-dark.svg';
import { ReactComponent as AITypeRequestHardwareIcon } from '@assets/svg/add-ai/ic-requestHardware.svg';

import { selectAppPersistDarkMode } from '@store/useAppStorePersist';

const iconsList = {
  AITypeFailureComponentIcon: <AITypeFailureComponentIcon />,
  AITypeFailureHardwareIcon: <AITypeFailureHardwareIcon />,
  AITypeRequestComponentIcon: <AITypeRequestComponentIcon />,
  AITypeRequestHardwareIcon: <AITypeRequestHardwareIcon />,
};

const darkIconsList = {
  AITypeFailureComponentIcon: <AITypeFailureComponentDarkIcon />,
  AITypeFailureHardwareIcon: <AITypeFailureHardwareDarkIcon />,
  AITypeRequestComponentIcon: <AITypeRequestComponentDarkIcon />,
  AITypeRequestHardwareIcon: <AITypeRequestHardwareDarkIcon />,
};

const AiTypeIcon = ({ iconKey }) => {
  const darkMode = selectAppPersistDarkMode();

  if (!iconKey) {
    return null;
  }

  return darkMode ? darkIconsList[iconKey] : iconsList[iconKey];
};

export default AiTypeIcon;
